import { fromAnyDateToIso, fromAnyDateToTimestamp } from 'utils/converters/time/from.util';
import detectDst from 'utils/date/detectDst.util';
import logger from 'utils/logger.util';
import isValidIsoFormat from 'utils/predicates/time/isValidIsoFormat.util';

const L = logger('correctIsoForDst');

const correctIsoForDst = (iso) => {
  if (!isValidIsoFormat(iso)) {
    L.warn('()', 'Invalid iso:', iso);
    return '';
  }

  const dst = detectDst(iso);
  if (!dst) return iso;

  const timestamp = fromAnyDateToTimestamp(iso);
  if (!timestamp) return iso;

  return fromAnyDateToIso(timestamp - dst);
};

export default correctIsoForDst;
